var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AddBinsDialog',{attrs:{"value":"true","loading":_vm.loading,"start-number":_vm.startNumber,"bin":_vm.bin},on:{"ok":_vm.onOk,"cancel":_vm.onCancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }